<div
  class="app-select"
  [class.app-select--auth]="appearance === 'auth'"
  [class.is-open]="isOpen"
  [class.is-invalid]="invalid"
  [class.is-disabled]="isDisabled"
  [class.is-placeholder]="showPlaceholderState">
  <button
    type="button"
    class="app-select__trigger"
    [id]="inputId || null"
    [disabled]="isDisabled"
    [attr.aria-expanded]="isOpen"
    aria-haspopup="listbox"
    [attr.aria-labelledby]="ariaLabelledby || null"
    (click)="toggle(); $event.stopPropagation()">
    <span class="app-select__label">{{ selectedLabel }}</span>
    <i class="fas fa-chevron-down app-select__chevron" aria-hidden="true"></i>
  </button>

  <ul class="app-select__menu" role="listbox" *ngIf="isOpen" (click)="$event.stopPropagation()">
    <li *ngIf="placeholder" role="option" [attr.aria-selected]="showPlaceholderState">
      <button
        type="button"
        class="app-select__option app-select__option--placeholder"
        [class.is-selected]="showPlaceholderState"
        (click)="selectPlaceholder()">
        <span>{{ placeholder }}</span>
      </button>
    </li>
    <li
      *ngFor="let option of options"
      role="option"
      [attr.aria-selected]="isSelected(option)">
      <button
        type="button"
        class="app-select__option"
        [class.is-selected]="isSelected(option)"
        (click)="selectOption(option)">
        <span>{{ option.label }}</span>
        <i class="fas fa-check" *ngIf="isSelected(option)" aria-hidden="true"></i>
      </button>
    </li>
  </ul>
</div>
